import { gql } from 'apollo-boost'

export const GET_FAQS = gql`
  query getFaqs {
    listFaqCategories {
      id
      index
      name
      questions {
        question
        answer
        index
      }
    }
  }
`
